import React, {useEffect, useState} from "react";
import proj4 from "proj4";
import {detailparcelleStyles} from "./styles";
import {Box, Link, CircularProgress} from "@mui/material";
import {useApplication} from "../../../hooks/UseApplication";
import {searchLocations} from "../../../service/geoApiService";
import {buildingService} from "../../../service/BuildingService";

import localChIcon from "../../../assets/Images/logo/logo-localch.png";
import googleChIcon from "../../../assets/Images/logo/googlech.png";

const DetailInfos = () => {
    const {details} = useApplication();
    const [modifiedGeoPortaLink, setModifiedGeoPortaLink] = useState("");

    // Définir les projections
    const wgs84 = "EPSG:4326";
    const lv95 = "EPSG:2056";

    const [mn95X, setMn95X] = useState(null);
    const [mn95Y, setMn95Y] = useState(null);
    const [coordsMN95, setCoordsMN95] = useState({x: null, y: null});
    const [batiments, setBatiments] = useState([]);

    const [solarPotentialUrl, setSolarPotentialUrl] = useState("");
    const [isSolarPotentialLoading, setIsSolarPotentialLoading] = useState(false);
    const [solarPotentialError, setSolarPotentialError] = useState("");


    useEffect(() => {
        if (details?.center?.lat && details?.center?.lon) {
            // Ajouter la définition de la projection LV95 (CH1903+/LV95)
            proj4.defs(
                lv95,
                "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +datum=ch1903 +units=m +no_defs"
            );

            // Convertir les coordonnées
            const [x, y] = proj4(wgs84, lv95, [
                details.center.lon,
                details.center.lat,
            ]);

            setCoordsMN95({x, y});

            // Construire le lien avec les coordonnées MN95 arrondies
            if (details.geo_portal_link) {

                const parcelle = '&locparcelle=' + details.no_parcelle;
                const adresseId = '&locadresse=' + details.address_id;
                const centerMark = '&keepgraphic=true&addcrosshair=true';

                setModifiedGeoPortaLink(
                    details.geo_portal_link
                        .replace("mapresources=AMENAGEMENT", "mapresources=AMENAGEMENT,CADASTRE")
                        .replace("scale=750", "scale=500")
                        .replace("{x}", Math.round(x))
                        .replace("{y}", Math.round(y)) + parcelle + adresseId + centerMark
                );
            }
        }
    }, [details]);

    useEffect(() => {
        const fetchBuildings = async () => {
            try {
                if (!details?.old_lands_id) {
                    console.warn("⚠️ Aucun old_lands_id trouvé dans details — on ne fetch pas les bâtiments.");
                    return;
                }

                const buildingsData = await buildingService.findByLandId(details.old_lands_id);


                if (!Array.isArray(buildingsData)) {
                    console.warn("⚠️ [fetchBuildings] Format inattendu, attendu un tableau :", buildingsData);
                }

                setBatiments(buildingsData || []);
            } catch (error) {
                console.error("❌ Erreur lors de la récupération des bâtiments :", error);
                setBatiments([]);
            }
        };

        fetchBuildings();
    }, [details?.old_lands_id]);


    const calculateSolarPotential = async () => {
        console.log("lat", details);

        if (!details.center.lat || !details.center.lon) {
            setSolarPotentialError("Coordonnées manquantes");
            return;
        }

        setIsSolarPotentialLoading(true);
        setSolarPotentialError("");

        try {
            const result = await searchLocations(
                details.center.lat,
                details.center.lon
            );

            console.log("result >>", result);

            if (result?.featureId) {
                const url = `https://www.uvek-gis.admin.ch/BFE/sonnendach/index.html?featureId=${result.featureId}&lang=fr`;
                setSolarPotentialUrl(url);
            } else {
                setSolarPotentialError("Données d'ensoleillement non disponibles");
            }
        } catch (error) {
            console.error("Erreur lors du calcul du potentiel solaire:", error);
            setSolarPotentialError("Erreur lors de la récupération des données");
        } finally {
            setIsSolarPotentialLoading(false);
        }
    };

    useEffect(() => {
        if (details.land_id) {
            calculateSolarPotential();
        }
    }, [details.land_id]);

    const renderSolarPotentialJsx = () => {
        if (isSolarPotentialLoading) {
            return <CircularProgress size={20} sx={{ml: 1}}/>;
        }

        if (solarPotentialError) {
            return <span style={{marginLeft: "8px"}}>Indisponible</span>;
        }

        if (solarPotentialUrl) {
            return (
                <Link
                    href={solarPotentialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: '#000000',
                        textDecorationColor: '#000000',
                    }}
                >
                    Voir
                </Link>
            );
        }

        return <span style={{marginLeft: "8px"}}>Aucune donnée</span>;
    };

    const renderBatimentsJsx = () => {
        if (!batiments || batiments.length === 0) {
            return (
                <Box className="mt-4 p-4" style={detailparcelleStyles.grayBg}>
                    Pas de bâtiments disponible
                </Box>
            );
        }

        return batiments.map((batiment, index) => (
            <Box className="pt-4 col-md-4" key={batiment.EGID || index}>
                <h5 style={detailparcelleStyles.fontWeightTitle}>
                    BÂTIMENT {index + 1}
                </h5>
                <Box
                    className="d-flex justify-content-between p-4"
                    style={detailparcelleStyles.grayBg}
                >
                    {renderBatimentJsx(batiment)}
                </Box>
            </Box>
        ));
    };

    const renderBatimentJsx = (batiment) => {
        if (!batiment) return null;

        return (
            <Box className="me-2" style={detailparcelleStyles.cellWdth}>
                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          EGID :
        </span>{" "}
                    {batiment.EGID || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Canton :
        </span>{" "}
                    {batiment.canton || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Commune :
        </span>{" "}
                    {batiment.nom_commune || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Adresse :
        </span>{" "}
                    {batiment.adresse || "—"}

                    <Box
                        sx={{marginBottom: {xl: 0, lg: 0, md: 0, sm: 2, xs: 2}}}
                        className="d-flex align-items-center"
                    >

                        <a
                            href={localChUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                height="20"
                                alt="google.ch"
                                src={localChIcon}
                                style={{objectFit: "contain"}}
                            />
                        </a>

                        <a
                            href={googleChUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-2"
                        >
                            <img
                                height="20"
                                alt="google.ch"
                                src={googleChIcon}
                                style={{objectFit: "contain"}}
                            />
                        </a>
                    </Box>

                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          EGRID :
        </span>{" "}
                    {batiment.EGRID || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Numéro parcelle :
        </span>{" "}
                    {batiment.no_parcelle || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Numéro bâtiment :
        </span>{" "}
                    {batiment.no_batiment || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Période de construction :
        </span>{" "}
                    {batiment.periode_construction || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Statut :
        </span>{" "}
                    {batiment.statut_batiment || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Catégorie :
        </span>{" "}
                    {batiment.category_batiment || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Classe :
        </span>{" "}
                    {batiment.classe_batiment || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Nombre de niveaux :
        </span>{" "}
                    {batiment.nombre_niveau || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Surface :
        </span>{" "}
                    {batiment.surface_batiment ? `${batiment.surface_batiment} m²` : "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Début construction :
        </span>{" "}
                    {batiment.debut_construction || "—"}
                </p>

                <p>
        <span style={{color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle}}>
          Fin construction :
        </span>{" "}
                    {batiment.fin_construction || "—"}
                </p>

                {batiment.EGID && (
                    <p>
          <span
              style={{
                  color: detailparcelleStyles.graylight,
                  ...detailparcelleStyles.fontWeightTitle,
              }}
          >
            Lien officiel :
          </span>{" "}
                        <Link
                            href={`https://www.housing-stat.ch/fr/query/egid.html?egid=${batiment.EGID}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#000000',
                                textDecorationColor: '#000000',
                            }}
                        >
                            Voir
                        </Link>
                    </p>
                )}
            </Box>
        );
    };

    const formatSearchUrl = (baseUrl, query) => {
        return `${baseUrl}${encodeURIComponent(query)}`;
    };

    const query = details.address_full;

    const googleChUrl = formatSearchUrl(
        "https://www.google.ch/search?q=",
        query
    );

    const localChUrl = formatSearchUrl(
        "https://www.local.ch/fr/s/",
        query
    );


    return (
        <Box
            className="Layout bg-white my-4 rounded"
            sx={{
                display: "flex",
                height: "auto",
                flexWrap: "wrap",
                flexDirection: {
                    xl: "row",
                    lg: "row",
                    md: "row",
                    sm: "column-reverse",
                    xs: "column-reverse",
                },
                borderTopRightRadius: "8px",
                borderTopLeftRadius: {lg: 0, md: 0, sm: "8px", xs: "8px"},
                justifyContent: {
                    lg: "inherit",
                    md: "inherit",
                    sm: "flex-end",
                    xs: "flex-end",
                },
            }}
        >
            <Box
                className="container-fluid"
                sx={{
                    width: {
                        xl: "100%",
                        lg: "100%",
                        md: "100%",
                        sm: "100%",
                        xs: "100%",
                    },
                }}
            >
                <Box className="row">
                    <Box className="col-12 px-4 p-4 pb-0">
                        <h4 style={detailparcelleStyles.fontWeightTitle}>INFORMATIONS</h4>
                        <Box
                            className="d-flex justify-content-between p-4  "
                            sx={{...detailparcelleStyles.grayBg, ...detailparcelleStyles.flexWrapMobile}}
                        >
                            <Box className="mx-2" sx={detailparcelleStyles.cellWdth}>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    N° parcelle :
                  </span>{" "}
                                    {details.no_parcelle}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Type :
                  </span>{" "}
                                    {details.type === "private" ? "Privé" : "Public"}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Type de plan :
                  </span>{" "}
                                    {details.type_plan}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Adresse :
                  </span>{" "}
                                    {details.address_full}

                                    <Box
                                        sx={{marginBottom: {xl: 0, lg: 0, md: 0, sm: 2, xs: 2}}}
                                        className="d-flex align-items-center"
                                    >

                                        <a
                                            href={localChUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                height="20"
                                                alt="google.ch"
                                                src={localChIcon}
                                                style={{objectFit: "contain"}}
                                            />
                                        </a>

                                        <a
                                            href={googleChUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="me-2"
                                        >
                                            <img
                                                height="20"
                                                alt="google.ch"
                                                src={googleChIcon}
                                                style={{objectFit: "contain"}}
                                            />
                                        </a>
                                    </Box>
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Commune OFS n<sup>°</sup> :
                  </span>{" "}
                                    {details.commune_ofs}
                                </p>
                            </Box>
                            <Box className="mx-2" sx={detailparcelleStyles.cellWdth}>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Surface parcelle :
                  </span>{" "}
                                    {details.surface} m<sup>2</sup>
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Surface bâtiment :
                  </span>{" "}
                                    {details.building_total_area} m<sup>2</sup>
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Etage max :
                  </span>{" "}
                                    {details.max_floor_nb}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Hauteur max :
                  </span>{" "}
                                    {details.max_height
                                        ? `${details.max_height} m`
                                        : "Non spécifié"}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Nom Zone :
                  </span>{" "}
                                    {details.zone}
                                </p>
                            </Box>
                            <Box className="mx-2" sx={detailparcelleStyles.cellWdth}>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    EGRID :
                  </span>{" "}
                                    {details.egrid}
                                </p>
                                {details.rf_uri === "" || (
                                    <p>
                    <span
                        style={{
                            color: detailparcelleStyles.graylight,
                            ...detailparcelleStyles.fontWeightTitle,
                        }}
                    >
                      Registre Foncier :
                    </span>

                                        {details.rf_uri ? (
                                            <Link
                                                href={details.rf_uri}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#000000',
                                                    textDecorationColor: '#000000',
                                                }}>
                                                Voir
                                            </Link>
                                        ) : (
                                            ""
                                        )}
                                    </p>
                                )}
                                {modifiedGeoPortaLink === "" || (
                                    <p>
                    <span
                        style={{
                            color: detailparcelleStyles.graylight,
                            ...detailparcelleStyles.fontWeightTitle,
                        }}
                    >
                      Géoportail :
                    </span>

                                        {modifiedGeoPortaLink ? (
                                            <Link
                                                href={modifiedGeoPortaLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#000000',
                                                    textDecorationColor: '#000000',
                                                }}>
                                                Voir
                                            </Link>
                                        ) : (
                                            ""
                                        )}
                                    </p>
                                )}
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Cadastre :
                  </span>

                                    {details.cadastreLink ? (
                                        <Link
                                            href={details.cadastreLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#000000',
                                                textDecorationColor: '#000000',
                                            }}
                                        >
                                            Télécharger
                                        </Link>
                                    ) : (
                                        ""
                                    )}
                                </p>
                                <p>
                  <span
                      style={{
                          color: detailparcelleStyles.graylight,
                          ...detailparcelleStyles.fontWeightTitle,
                      }}
                  >
                    Ensoleillement:
                  </span>

                                    {renderSolarPotentialJsx()}
                                </p>
                            </Box>
                        </Box>
                    </Box>
                    <Box className="row p-4">{renderBatimentsJsx()}</Box>
                </Box>
            </Box>
        </Box>
    );
};

export default DetailInfos;
